import React, { useMemo } from "react";
import { parseDate, getSubMonths } from "@Util/moment.util";
import { Box, MenuItem, SelectField } from '@curves/ui-base';

const MonthSelector = ({ selectedMonth, onMonthChange }) => {
  // 取得前三個月（不含當月）
  const monthOptions = useMemo(() => {
    const list = [];
    const today = new Date();
    for (let i = 1; i <= 3; i++) {
      const m = getSubMonths(today, i);
      list.push({
        value: parseDate(m, "YYYYMM"),
        label: parseDate(m, "YYYY年M月"),
      });
    }
    return list;
  }, []);
  const handleChange = (event, node, value) => {
    onMonthChange(value ?? event.target.value);
  };
  return (
    <Box>
      <SelectField
        value={selectedMonth || ""}
        onChange={handleChange}
        fullWidth
        displayEmpty
        label="選擇月份"
      >
        <MenuItem value="" disabled>
          <em>請選擇</em>
        </MenuItem>
        {monthOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </SelectField>
    </Box>
  );
};
export default MonthSelector;
